var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44578 0.5H11.2771L7.27711 5.16889L12 11.5H8.28916L5.39759 7.66222L2.07229 11.5H0.240964L4.53012 6.51333L0 0.5H3.80723L6.43374 4.02L9.44578 0.5ZM8.79518 10.3756H9.80723L3.25301 1.55111H2.14458L8.79518 10.3756Z",
    fill: "#BFBFC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.208831f76382bba8779c452acbc52356.svg";
export { ForwardRef as ReactComponent };